import React from "react"
import { BrowserRouter, withRouter } from "react-router-dom"
import MainRouter from "./MainRouter"
import { connect, Provider } from "react-redux"
import { configureStore } from "./store/configureStore"
import { ThemeProvider, createTheme } from 'arwes';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './style.scss'
import { refreshViewer, updateUser } from "./components/user/redux/reducers"
import ErrorBoundary from "./components/ErrorBoundary"

const store = configureStore()

// Rehydrate auth from localStorage so a hard refresh keeps the user
// signed in. Without this, state.user.loaded.token is undefined on
// boot even though the JWT is still in localStorage.
try {
  const raw = typeof window !== "undefined" && window.localStorage.getItem("jwt")
  if (raw) {
    const parsed = JSON.parse(raw)
    if (parsed && parsed.token) {
      store.dispatch(updateUser(parsed))
      // Older token blobs predate the avatar field — pull the viewer's
      // current profile so identity surfaces (composer, rails) are fresh.
      if (parsed.user && parsed.user._id) {
        store.dispatch(refreshViewer(parsed.user._id))
      }
    }
  }
} catch (e) {
  // ignore corrupted localStorage
}

// https://github.com/arwesjs/arwes/blob/master/packages/arwes/src/tools/createTheme/theme.js

const myTheme = {
  animTime: 250,
  color: {
    primary: {
      base: '#be26fc',
      dark: '#8e1bbd',
      light: '#c95bf6'
    },
    header: {
      base: '#fc26fa',
      dark: '#a818a7',
      light: '#f458f2'
    },
    animate: {
      primary: {
        base: '#030021',
      },
      base: '#030021',
    }
  },

};


const App = () => (
  <ErrorBoundary>
    <ThemeProvider theme={createTheme(myTheme)}>
      <Provider store={store}>
        <BrowserRouter>
          <MainRouter />
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  </ErrorBoundary>
)

const mapState = state => {
  return {
    placeholder: state
  }
}
export default withRouter(connect(mapState)(App))
